import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHeadTypes} from "../../constants";

export default class ShowerSystem extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_system';
    this.partName = 'Shower System';
    this.translateId = "visualizer.bathroom.shower.shower_system";
    this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    const showerParent = this.getParent().getParent();
    showerParent.setShowerHeadType(ShowerHeadTypes.shower_system);
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_system && this.activeFeature
  }
}
